module.exports = __webpack_public_path__ + "static/media/subtraction_levels.bbb8e81c.png";